import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Action } from "../../internal/Action.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
/**
 * @description Specifies the ICC profile to use for the color space.
 * @memberOf Actions.Delivery
 * @extends SDK.Action
 * @see Visit {@link Actions.Delivery|Delivery} for an example
 */
var DeliveryColorSpaceFromICCAction = /*#__PURE__*/function (_Action) {
  /**
   * @param {string} publicId
   */
  function DeliveryColorSpaceFromICCAction(publicId) {
    var _this;
    _classCallCheck(this, DeliveryColorSpaceFromICCAction);
    _this = _callSuper(this, DeliveryColorSpaceFromICCAction);
    _this._actionModel = {};
    _this._actionModel.actionType = 'colorSpaceFromICC';
    _this._actionModel.publicId = publicId;
    var qualifierValue = new QualifierValue(['icc', publicId]).setDelimiter(':');
    _this.addQualifier(new Qualifier('cs', qualifierValue));
    return _this;
  }
  _inherits(DeliveryColorSpaceFromICCAction, _Action);
  return _createClass(DeliveryColorSpaceFromICCAction, null, [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var publicId = actionModel.publicId;
      return new this(publicId);
    }
  }]);
}(Action);
export { DeliveryColorSpaceFromICCAction };